import React from "react";
import {
  IconBoxInfo,
  IconHandShake,
  IconLock,
} from "../../components/Icons/Icons";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import { Box } from "@mui/system";

export const TCTab = () => {
  return (
    <div>
      <div className="page-security-head" style={{ padding: "5px 0px 0px" }}>
        <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center", margin: "15px 0" }}>
          <IconBoxInfo
            colorIcon={"#1b4ec1"}
            height={"20px"}
            width={"25px"}
          />
          <span style={{ marginLeft: "10px" }}>Documentos relevantes</span>
        </div>
      </div>
      <div className="infoTec" style={{ marginTop: "10px" }}>
        <div className="infoTecBox">
          <div className="icon-box" style={{ float: "left" }}>
            <IconHandShake />
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="infoTecBoxTitle">Términos y condiciones</div>
              <Box display="flex" alignItems="left">
                <AttachFileOutlinedIcon sx={{ color: "#5B6576", width: 15 }} />
                <div className="infoTecBoxText">terminos_condiciones.pdf</div>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <div className="infoTec" style={{ marginTop: "10px" }}>
        <div className="infoTecBox">
          <div className="icon-box" style={{ float: "left" }}>
            <IconLock />
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="infoTecBoxTitle">
                Política de tratamiento de datos
              </div>
              <Box display="flex" alignItems="center">
                <AttachFileOutlinedIcon sx={{ color: "#5B6576", width: 15 }} />
                <div className="infoTecBoxText">tratamiento_datos.pdf</div>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
